import React from "react";
import ReactDOM from "react-dom";

// Import Flag Icons Set
// import "flag-icon-css/css/flag-icon.min.css";

// Import Font Awesome Icons Set
import "font-awesome/css/font-awesome.min.css";

//bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

//material ui css
import "@sijal/common/src/static/css/material-dashboard-react.css";

//my styles
// import './static/css/vender.css'
import "@sijal/common/src/static/css/styles.css";

import * as serviceWorker from "./serviceWorker";
import MainRoute from "./config/routes";
import { Router } from "react-router-dom";
import history from "@sijal/common/src/config/history";
import { ApolloProvider } from "@apollo/client";
import { SnackbarProvider } from "notistack";
import { createClient } from "@sijal/common/src/config/apollo";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CLIENT_ID } from "@sijal/common/src/config/CONSTANTS";

export const client = createClient();

Sentry.init({
  dsn:
    "https://7ae8a39c9a4046e7ba2c07ca43fc3de2@o144894.ingest.sentry.io/5672707",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.3,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <SnackbarProvider
      maxSnack={5}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <GoogleOAuthProvider clientId={CLIENT_ID}>
        <Router history={history}>
          <MainRoute></MainRoute>
        </Router>
      </GoogleOAuthProvider>
    </SnackbarProvider>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
